<template>
    <rkm-overlay>
        <rkm-layout-body title="Agendar transporte">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    v-if="isPermissaoCadastro"
                    @click.stop="$refs.ModalPacienteCadastroSimplificado.open(id)"
                >
                    Editar paciente
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.preAgendar()"
                    color="info"
                >
                    Viagem pré agendada
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    :id="id"
                    @save="handleSave"
                    @handleExitPaciente="handleExitPaciente"
                    @handleAtualizaPaciente="handleAtualizaPaciente"
                    @permissao="handlePermissao"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
        <ModalPacienteCadastroSimplificado
            ref="ModalPacienteCadastroSimplificado"
            @save="reloadTransporteAgendar"
        />
    </rkm-overlay>
</template>

<script>

// Components.
import Form from '@/components/transporte-paciente/agendar/Form'
import ModalPacienteCadastroSimplificado from '@/components/cadastro/paciente/components/cadastro-simplificado/Modal'

// Vuex.
import { mapActions } from 'vuex';

// Enums.
import classificacao from '@/enums/cadastro/paciente/classificacao'

export default {
    components: { Form, ModalPacienteCadastroSimplificado },
    created() {
        this.setShowExitFormConfirmation()
    },
    data: () => ({
        isPermissaoCadastro: null,
        enums: {
            classificacao,
        },
    }),
    methods: {
        ...mapActions([
            'setShowExitFormConfirmation',
            'unsetShowExitFormConfirmation'
        ]),
        handleExit() {
            this.$router.push({ name: 'transporte-paciente-agendar-list' })
        },
        handleSave() {
            this.unsetShowExitFormConfirmation()
            this.handleExit()
        },
        handleExitPaciente() {

            this.unsetShowExitFormConfirmation()
            this.handleExit()
        },
        handleAtualizaPaciente() {

            this.unsetShowExitFormConfirmation()
            this.$router.push({ name: 'cadastro-paciente-edit', params: { id: this.id } })
        },
        reloadTransporteAgendar() {
            this.$router.go(0);
        },
        handlePermissao(item) {

            if (item.isPermissaoCadastro) {
                this.isPermissaoCadastro = true;
            } else {

                const classificacoes = item.classificacoes;
                const classificacaoId = item.paciente.classificacaoId;

                const isClassificacaoPresent = (classificacaoId) => {
                    return classificacoes.some(classificacao => classificacao.id === classificacaoId);
                };

                switch (classificacaoId) {
                    case this.enums.classificacao.MUNICIPE:
                    case this.enums.classificacao.PROVISORIO:
                    case this.enums.classificacao.OUTRO_MUNICIPIO:
                        this.isPermissaoCadastro = isClassificacaoPresent(classificacaoId);
                        break;
                    default:
                        this.isPermissaoCadastro = false;
                }
            }
        }
    },
    props: {
        id: { type: Number, default: null }
    },
}
</script>